import { IconButton } from "@material-ui/core";

export type { IconButtonProps } from "@material-ui/core";

export default IconButton;
